import React, { Fragment } from 'react';

import { Col, Container, Row } from 'reactstrap';
import MatTable from './components/MatTable';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';
import { Redirect, withRouter } from 'react-router-dom';
import TrialAlert from '../../shared/components/payment/TrialAlert';

import EnterpriseGate from '../../shared/components/payment/EnterpriseGate';
import { _hasPermission	} from "../../shared/helpers/access";

import QuickStartGuide from '../../shared/components/QuickStartGuide';

import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  isTablet
} from "react-device-detect";

import{
	_capitalizeText,
} from '../../shared/helpers/utils';

const PropertySearch = ( {user, match } ) => {

	  return(
		  <Container>
		    <Row>
		      <Col md={12}>
		        <h3 className="page-title">Property Search</h3>
		       {!isMobile && <h3 className="page-subhead subhead">Search All Properties by Type, Location, Size, Price and More.</h3> }
		      </Col>
		    </Row>
		    {_hasPermission(user, 'building-search') ?
			    <Fragment>
				    <Row>
				      <Col md={12} className={'mb-3'}>
				       	<TrialAlert />
				      </Col>
				    </Row>
				    <Row>
				      <MatTable />
				    </Row>
			    </Fragment>
			    :
			     <Row>
				    <EnterpriseGate />
				 </Row>
		    }
		  </Container>
		  )

};


export default connect(state => ({
  user: state.user,
}))(withOktaAuth(withRouter(PropertySearch)));
